import React from 'react';
import './DateItem.scss';

interface DateItemProps {
  label: string;
  value: string;
  month: string;
  type: 'start-date' | 'end-date';
}

export const DateItem: React.FC<DateItemProps> = ({ label, value, month, type }) => {
  return (
    <div className={`date-item ${type}`}>
      <span className="date-label">{label}</span>
      <span className="date-value">{value}</span>
      <span className="date-month">{month}</span>
    </div>
  );
};
